import React, { useState, useEffect } from 'react';
import { useLocation, Link } from 'react-router-dom';
import './Navbar.css';
import { FireSimple } from '@phosphor-icons/react';
import { PUBLIC_ROUTES } from '../constants/routes';

function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  // Function to handle navigation links
  const handleNavLink = (sectionId) => {
    // If we're not on the home page, navigate to home with the section
    if (location.pathname !== '/') {
      window.location.href = `/#${sectionId}`;
    } else {
      // If we're already on home page, just scroll to the section
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  // Handle hash navigation when component mounts or location changes
  useEffect(() => {
    if (location.pathname === '/' && location.hash) {
      // Remove the # from the hash
      const sectionId = location.hash.substring(1);
      const element = document.getElementById(sectionId);
      if (element) {
        // Small delay to ensure the page is fully loaded
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
    }
  }, [location]);

  // Disable scroll when mobile menu is open
  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    // Cleanup function to restore scroll when component unmounts
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isMenuOpen]);

  return (
    <nav className="navbar">
      <div className="navbar-card">
        <a href="/" className="navbar-logo">
          <img src="https://firebasestorage.googleapis.com/v0/b/wesplit-35186.firebasestorage.app/o/website%2Fwesplit-logo.png?alt=media&token=4f50d17a-de63-455e-bb13-9a6950784159" alt="WeSplit" />
        </a> 
        
        {/* Desktop Navigation */}
        <ul className="navbar-links desktop-nav">
          <li><a href="#" onClick={(e) => { e.preventDefault(); handleNavLink('splitmethods'); }}>Split Modes</a></li>
          <li><a href="#" onClick={(e) => { e.preventDefault(); handleNavLink('solution'); }}>Shared Wallets</a></li>
          <li><a href="#" onClick={(e) => { e.preventDefault(); handleNavLink('social'); }}>Social Layer</a></li>
          <li><a href="#" onClick={(e) => { e.preventDefault(); handleNavLink('earn'); }}>Earn</a></li>
          <li><a href="#" onClick={(e) => { e.preventDefault(); handleNavLink('faq'); }}>FAQ</a></li>
        </ul>
        <div className="navbar-action desktop-download">
          <a href="#download" onClick={(e) => { e.preventDefault(); handleNavLink('download'); }} className="primary"><FireSimple weight="fill" size={20} />Start Splitting</a>
        </div>

        <button className="navbar-burger" onClick={toggleMenu}>
          {isMenuOpen ? '✕' : '☰'}
        </button>
      </div>

      {/* Mobile Navigation */}
      <div className={`navbar-mobile-content ${isMenuOpen ? 'open' : ''}`}>
        <div className="navbar-mobile-card">
          <ul className='navbar-links mobile-nav'>
            <li><a href="#" onClick={(e) => { e.preventDefault(); handleNavLink('splitmethods'); closeMenu(); }}>Split Modes</a></li>
            <li><a href="#" onClick={(e) => { e.preventDefault(); handleNavLink('solution'); closeMenu(); }}>Shared Wallets</a></li>
            <li><a href="#" onClick={(e) => { e.preventDefault(); handleNavLink('social'); closeMenu(); }}>Social Layer</a></li>
            <li><a href="#" onClick={(e) => { e.preventDefault(); handleNavLink('earn'); closeMenu(); }}>Earn</a></li>
            <li><a href="#" onClick={(e) => { e.preventDefault(); handleNavLink('faq'); closeMenu(); }}>FAQ</a></li>
          </ul>
          <div className="navbar-action mobile-download">
            <a href="#download" onClick={(e) => { e.preventDefault(); handleNavLink('download'); closeMenu(); }} className="primary"><FireSimple weight="fill" size={20} />Start Splitting</a>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Navbar; 